import { useCallback } from "react"

import { DocumentForm } from "@l2r-front/l2r-app-doc"
import { useTranslation } from "@l2r-front/l2r-i18n"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { useRoadworkUpdateDocument } from "../../hooks/mutations/roadwork/useRoadworkUpdate"

export const RoadworkAddDocumentForm = (props) => {
    const {
        roadwork,
        onClose,
        onSubmitting,
        onChange,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    const mutation = useRoadworkUpdateDocument(roadwork, {}, {
        errorSnackbarMessage: t(I18N_NAMESPACE, "containers.roadworkSectionDocumentEditForm.snackbar.error"),
        successSnackbarMessage: t(I18N_NAMESPACE, "containers.roadworkSectionDocumentEditForm.snackbar.success"),
        onSuccess: () => onClose(false),
        onError: (error) => {
            onSubmitting(false)
            console.error("Error updating roadwork section document:", error)
        },
    })

    const onSubmit = useCallback((formValues) => {
        const values = {
            document: formValues,
        }
        mutation.mutate(values)
        onSubmitting(true)
    }, [mutation, onSubmitting])

    return <DocumentForm
        isSubmitting={mutation.isPending}
        onSubmit={onSubmit}
        onCancel={() => onClose()}
        onChange={onChange}
    />
}